import {combineReducers} from 'redux';
import auth from './auth';
import event from './event';
import language from './language';
import config from './config';
import general from './general';
import translations from './translations';

export default combineReducers({
    auth,
    event,
    language,
    config,
    general,
    translations
});
